import React from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useSystemsContext } from "../../context/SystemsContext";
import SystemSettingsForm from "./forms/SystemSettingsForm";

const formatLastViewedAt = (value?: string) => {
  if (!value) {
    return "Never";
  }

  const timestamp = Number(value);
  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return "Never";
  }

  return new Date(timestamp * 1000).toLocaleString();
};

const SystemDetails: React.FC = () => {
  const { formData } = useSystemsContext();

  const iframeMetrics = [
    {
      label: "UC iframe views",
      value: formData?.iframeUcViewCount ?? 0,
    },
    {
      label: "Pano iframe views",
      value: formData?.iframePanoViewCount ?? 0,
    },
    {
      label: "Last iframe view",
      value: formatLastViewedAt(formData?.iframeLastViewedAt),
    },
  ];

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {formData?.commonName || "System Details"}
      </Typography>

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Iframe Analytics
          </Typography>
          <Grid container spacing={2}>
            {iframeMetrics.map((metric) => (
              <Grid item xs={12} md={4} key={metric.label}>
                <Box>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    {metric.label}
                  </Typography>
                  <Typography variant="h6">{metric.value}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      <Typography variant="h6" sx={{ mb: 2, color: "text.secondary" }}>
        System Info
      </Typography>

      <SystemSettingsForm />
    </Box>
  );
};

export default SystemDetails;
